import { toastController } from '@ionic/vue';

let currentToast = null;

export default {
  async create(msg, color) {
    const previous = currentToast;
    currentToast = null;
    if (previous) {
      try {
        await previous.dismiss();
      } catch {
        // No toast to dismiss or already dismissed
      }
    }

    const toast = await toastController.create({
      message: msg,
      position: 'bottom',
      color,
      buttons: [{
        side: 'end',
        icon: 'close',
        role: 'cancel',
        cssClass: 'toast-close-button ios-close-visible',
      }],
    });

    currentToast = toast;
    await toast.present();
    toast.onDidDismiss().then(() => {
      currentToast = null;
    });
  },

  async dismiss() {
    const toast = currentToast;
    currentToast = null;
    if (toast) {
      try {
        await toast.dismiss();
      } catch {
        // No toast to dismiss or already dismissed
      }
    }
  },
};
